import React from 'react';
import SelectField from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';

class Select extends React.Component {

	menuItems(entries, selected) {

	    return entries.map((name) => (
	      <MenuItem
	        key={name}
	        insetChildren={true}
	        checked={selected && selected.includes(name)}
	        value={name}
	        style={{fontSize: '13px'}}
	      >{name}</MenuItem>
	    ));
  	}
  	handleChange(event, index, values) {

  		this.props.handleClick(event, index, values);
  	}
	render(){

		return (<div>
			{this.props.title ? (<div style={{fontSize:'1.1em'}}>{this.props.title}</div>) : ''}
			<SelectField
				id={this.props.id ? this.props.id : null}
				multiple={false}
				value={(this.props.selected[0] ? this.props.selected[0] : null)}
				onChange={this.handleChange.bind(this)}
				floatingLabelText={typeof this.props.label !== 'undefined' ? this.props.label : "pašvaldība"}
				labelStyle={{fontSize: '12px'}}
				style={{width: 180, fontSize: '12px'}}
				autoWidth={true}
				floatingLabelStyle={{fontWeight: '600', fontSize: '14px'}}
			>
		        {this.menuItems(this.props.entries, this.props.selected)}
	      	</SelectField>
		</div>);
	}
}

Select.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string,
  entries: PropTypes.array,
  selected: PropTypes.array,
  label: PropTypes.string
};

export default Select;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/select/index.js